import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { List, ListItem, ListItemText, Paper, Typography, Tooltip } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 400,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
  },
  title: {
    marginBottom: theme.spacing(2),
    textAlign: 'center',
    fontWeight: 'bold',
  },
  listItem: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}));

// Array of template strings with their descriptions
const templateStrings = [
  {
    name: '{{ACCT_NUM}}',
    description: 'The account number paired to the document. Account must be paired before extraction.'
  },
  {
    name: '{{METER_NUMBERS}}',
    description: 'List of all meter numbers actively tracked on this account.'
  },
  {
    name: '{{METER_INVENTORY}}',
    description: 'Detailed list of active meters, including account numbers, vendor names, and energy types.'
  },
  {
    name: '{{METER_INVENTORY_WITH_LATEST_USAGE_DATE}}',
    description: 'Detailed list of active meters with their latest usage dates, indicating where subsequent data begins.'
  },
  {
    name: '{{PROCESSING_NOTES}}',
    description: 'Notes attached to the account containing "[AI-PROCESSING]".'
  },
  {
    name: '{{LATEST_INVOICE_DATE}}',
    description: 'The most recent invoice date on the account.'
  },
  {
    name: '{{INVOICE_DATE}}',
    description: 'The invoice date of the bill being parsed.'
  },
  {
    name: '{{CURRENT_YEAR}}',
    description: 'The current year in four-digit format.'
  },
  {
    name: '{{TOTAL_CHARGES}}',
    description: 'Total charges as read by OCR.'
  },
];

const TemplateStringsList = ({ onTemplateSelect }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.root} elevation={3}>
      <Typography variant="h5" className={classes.title}>
        Template Strings
      </Typography>
      <List>
        {templateStrings.map((item, index) => (
          <Tooltip key={index} title={item.description}>
            <ListItem
              className={classes.listItem}
            >
              <ListItemText primary={item.name} />
            </ListItem>
          </Tooltip>
        ))}
      </List>
    </Paper>
  );
};

export default TemplateStringsList;